export function sameArrayValues(array1: any[], array2: any[]): boolean {
  return array1.sort().join(',') === array2.sort().join(',');
}
